import { ArrowUpRight, Bot, Globe, MessageCircle, Target, Workflow } from "lucide-react";
import { Eyebrow, Reveal } from "../components/Reveal";
import { SERVICES, waLink } from "../data/site";

const ICONS = { MessageCircle, Globe, Bot, Workflow, Target };

export const Solucoes = () => (
  <section id="solucoes" data-testid="solucoes-section" className="relative scroll-mt-24 bg-[#0B0F14]/70 py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <Eyebrow>02 · Soluções</Eyebrow>
        <h2 className="mt-5 max-w-2xl text-3xl font-semibold tracking-tight text-slate-100 sm:text-4xl lg:text-5xl">
          O que a AMB coloca de pé para o seu negócio
        </h2>
        <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-400">
          Cinco frentes que funcionam sozinhas ou juntas, conversando entre si.
        </p>
      </Reveal>

      <div className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="services-grid">
        {SERVICES.map((s, i) => {
          const Icon = ICONS[s.icon] ?? Globe;
          const featured = i === 0; // carro-chefe ocupa duas colunas no desktop: 2+1 em cima, 3 embaixo
          return (
            <Reveal key={s.name} delay={0.06 * i} className={featured ? "sm:col-span-2" : ""}>
              <a
                href={waLink(s.cta)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-card-${i}`}
                className={`group relative flex h-full flex-col overflow-hidden rounded-2xl border p-8 transition-[border-color,transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-[#007BFF]/40 hover:shadow-[0_18px_50px_rgba(0,60,160,0.18)] ${
                  featured
                    ? "border-[#007BFF]/30 bg-gradient-to-br from-[#0a1830] via-[#0B0F14] to-[#05070D]"
                    : "border-white/[0.07] bg-[#0d1219]"
                }`}
              >
                {featured && <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#007BFF]/20 blur-[90px]" />}
                <div className="relative flex h-12 w-12 items-center justify-center rounded-xl border border-[#007BFF]/25 bg-[#007BFF]/10 text-[#3a9bff] transition-transform duration-500 group-hover:scale-110">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className={`relative mt-6 font-semibold text-slate-100 ${featured ? "text-xl sm:text-2xl" : "text-lg"}`}>{s.name}</h3>
                <p className={`relative mt-3 flex-1 leading-relaxed text-slate-400 ${featured ? "max-w-lg text-base" : "text-sm"}`}>{s.desc}</p>
                <span className="relative mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-[#3a9bff] transition-colors duration-300 group-hover:text-white">
                  Falar sobre isso
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                </span>
              </a>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
